"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ExitfullscreenGreyOutline = _interopRequireDefault(require("@druva-apps/orion-icons/lib/ExitfullscreenGreyOutline"));

var _FullscreenGreyOutline = _interopRequireDefault(require("@druva-apps/orion-icons/lib/FullscreenGreyOutline"));

var _tooltip = _interopRequireDefault(require("../../tooltip"));

var _context = require("../context");

var _Settings = _interopRequireDefault(require("./Settings"));

var _ExportCsv = _interopRequireDefault(require("./ExportCsv"));

var _utils = require("../utils");

var Toolbar = function Toolbar(_ref) {
  var width = _ref.width,
      handleFullScreen = _ref.handleFullScreen,
      isFullScreen = _ref.isFullScreen,
      tableRef = _ref.tableRef;

  var _useTable = (0, _context.useTable)(),
      enableFullScreen = _useTable.enableFullScreen,
      enableExportToCsv = _useTable.enableExportToCsv,
      enableConfiguration = _useTable.enableConfiguration,
      selectedRows = _useTable.selectedRows,
      multiSelect = _useTable.multiSelect,
      selectedRowsCountText = _useTable.selectedRowsCountText,
      paginationEnabled = _useTable.paginationEnabled,
      uniqueDataKey = _useTable.uniqueDataKey,
      toolbarChildren = _useTable.toolbarChildren,
      data = _useTable.data;

  var currentRows = selectedRows;

  if (paginationEnabled) {
    var allRowIds = data ? (0, _map["default"])(data).call(data, function (obj) {
      return obj[uniqueDataKey];
    }) : [];
    currentRows = (0, _filter["default"])(selectedRows).call(selectedRows, function (rowId) {
      return (0, _includes["default"])(allRowIds).call(allRowIds, rowId);
    });
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "orion-data-grid__toolbar",
    style: {
      width: width
    }
  }, selectedRows.length > 0 && multiSelect && currentRows.length > 0 && /*#__PURE__*/_react["default"].createElement("span", {
    className: "oui-text-left oui-col-sm-3 oui-p-0 oui-text-truncate",
    title: selectedRowsCountText
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "oui-dg-list-count-number oui-d-inline-flex"
  }, selectedRows.length), selectedRowsCountText), /*#__PURE__*/_react["default"].createElement("div", {
    className: "oui-text-center oui-col-sm-5 oui-align-items-center oui-p-0 oui-d-inline-flex oui-justify-content-center"
  }, (0, _utils.isFunction)(toolbarChildren) ? toolbarChildren() : null), /*#__PURE__*/_react["default"].createElement("div", {
    className: "oui-text-right oui-col-sm-4 oui-p-0 oui-d-inline-flex oui-justify-content-end"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: ""
  }, !isFullScreen && enableExportToCsv && /*#__PURE__*/_react["default"].createElement(_ExportCsv["default"], {
    tableRef: tableRef
  })), /*#__PURE__*/_react["default"].createElement("span", null, enableExportToCsv && (enableConfiguration || enableFullScreen) && /*#__PURE__*/_react["default"].createElement("span", {
    className: "data-grid-toolbar-button-separator"
  }), !isFullScreen && enableConfiguration && /*#__PURE__*/_react["default"].createElement(_tooltip["default"], {
    text: "Customize Table Columns"
  }, /*#__PURE__*/_react["default"].createElement(_Settings["default"], {
    size: "sm",
    className: "oui-mr-2 data-grid-toolbar-button"
  })), enableFullScreen ? !isFullScreen ? /*#__PURE__*/_react["default"].createElement(_tooltip["default"], {
    text: "Enter Full Screen"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    onClick: handleFullScreen.enter,
    "aria-label": "Enter Full Screen",
    className: "orion-data-grid__navigation--empty-button data-grid-toolbar-button"
  }, /*#__PURE__*/_react["default"].createElement(_FullscreenGreyOutline["default"], {
    clickable: true
  }))) : /*#__PURE__*/_react["default"].createElement(_tooltip["default"], {
    text: "Exit Full Screen"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    onClick: handleFullScreen.exit,
    "aria-label": "Exit Full Screen",
    className: "orion-data-grid__navigation--empty-button data-grid-toolbar-button"
  }, /*#__PURE__*/_react["default"].createElement(_ExitfullscreenGreyOutline["default"], {
    clickable: true
  }))) : null)));
};

Toolbar.propTypes = {
  width: _propTypes["default"].number,
  handleFullScreen: _propTypes["default"].object,
  isFullScreen: _propTypes["default"].bool,
  tableRef: _propTypes["default"].object
};
var _default = Toolbar;
exports["default"] = _default;